import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GradingSchedule, GradingScheduleList, NewGradingSchedule} from './interface/grading-schedule.interface';
import 'rxjs-compat/add/operator/map';

@Injectable()
export class GradingScheduleService {
    constructor(private http: HttpClient) {
    }

    getTermList(): Observable<Array<GradingSchedule>> {
        return this.http.get<Array<GradingSchedule>>('/api/gradingSchedule');
    }

    getCurrentTerm(): Observable<GradingScheduleList> {
        return this.http.get<GradingScheduleList>('/gradingSchedule/current');
    }


    get(termCode: string): Observable<GradingScheduleList> {
        return this.http.get<GradingScheduleList>('/gradingSchedule/list?termCode=' + termCode);
    }


    post(tempGradingSchedule: NewGradingSchedule): Observable<Array<GradingScheduleList>> {
        return this.http.post<Array<GradingScheduleList>>('/api/gradingSchedule', tempGradingSchedule);
    }

    put(tempGradingSchedule: NewGradingSchedule): Observable<Array<GradingScheduleList>> {
        return this.http.put<Array<GradingScheduleList>>(
            '/api/gradingSchedule/' + tempGradingSchedule.id,
            tempGradingSchedule
        );
    }

    getAllOpenForGrading(): Observable<Array<GradingScheduleList>> {
        return this.http.get<Array<GradingScheduleList>>('/api/gradingSchedule/allOpenForGrading');
    }

    getAllCloseForGrading(): Observable<Array<GradingScheduleList>> {
        return this.http.get<Array<GradingScheduleList>>('/api/gradingSchedule/allCloseForGrading');
    }

    batchUpdateCloseSchedule(termCode: String): Observable<Array<GradingScheduleList>> {
        return this.http.put<Array<GradingScheduleList>>(
            '/api/gradingSchedule/batchUpdateCloseSchedule/' + termCode,
            ''
        );
    }


}
